import { render, staticRenderFns } from "./DataScreen.vue?vue&type=template&id=3244ceab&scoped=true"
import script from "./DataScreen.vue?vue&type=script&lang=js"
export * from "./DataScreen.vue?vue&type=script&lang=js"
import style0 from "./DataScreen.vue?vue&type=style&index=0&id=3244ceab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244ceab",
  null
  
)

export default component.exports